// @ts-strict-ignore
import React from 'react';

import { Box } from 'components/Box';
import { AnimatedCheckmark } from 'components/Icon/AnimatedCheckmark';
import { Spinner } from 'components/Spinner';
import { useCurrentUser } from 'store/main/hooks';

type Props = {
  submitting: boolean;
  isSubscribed: boolean;
};

export function ContentPageSubscribed({ submitting, isSubscribed }: Props) {
  const currentUser = useCurrentUser();

  if (!currentUser || !currentUser.isLoaded || submitting) {
    return <Spinner size="small" label="Submitting" />;
  }

  return (
    <Box display="flex" alignItems="center">
      {isSubscribed && (
        <Box display="flex" mr="8px">
          <AnimatedCheckmark size={24} initialColorName="turtleGreen" />
        </Box>
      )}
      {isSubscribed ? getText('Subscribed!') : getText('Subscribe')}
    </Box>
  );
}
